import React, { Component, PropTypes } from 'react';
import { findDOMNode } from 'react-dom';
import { connect } from 'react-redux';
import { Table, Well, Label, Button } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import exportTableAsExcel from '../utils/exportTableAsExcel';
import * as actionHorsesCreators from '../actions/horses';

const mapStateToProps = state => ({
  token: state.auth.token,
  horses: state.horses.horses,
});

const mapDispatchToProps = dispatch => ({
  actionsHorses: bindActionCreators(actionHorsesCreators, dispatch),
});

class Horses extends Component {
  static propTypes = {
    token: PropTypes.string.isRequired,
    actionsHorses: PropTypes.object.isRequired,
    horses: PropTypes.array.isRequired,
  };

  componentWillMount() {
    this.fetchData();
  }

  fetchData() {
    const { token, actionsHorses } = this.props;

    actionsHorses.fetchHorses(token);
  }

  downloadXls = () => {
    const tableElm = findDOMNode(this.refs.table);

    exportTableAsExcel(
      tableElm,
      'Additional Horses',
      `CVI ${window.cviConfig.cviCity} ${new Date().getFullYear()} - Additional Horses`
    );
  };

  render() {
    const { horses } = this.props;

    return (
      <div>
        <h3>Horses</h3>

        {!!horses.length && (
          <div>
            <Table striped bordered condensed hover responsive ref="table">
              <thead>
                <tr>
                  <th>Nation</th>
                  <th>Horse Name</th>
                  <th>Horse FEI ID</th>
                </tr>
              </thead>
              <tbody>
                {horses &&
                  horses.map(horse => (
                    <tr key={`h_${horse.feiId}_${horse.name}`}>
                      <td>{horse.nation}</td>
                      <td>{horse.name}</td>
                      <td>{horse.feiId}</td>
                    </tr>
                  ))}
              </tbody>
            </Table>

            <Label style={{ fontWeight: 600, fontSize: 14, padding: '10px 15px', float: 'right' }}>
              {horses.length} horses
            </Label>

            <Button type="button" bsStyle="primary" bsSize="xs" onClick={this.downloadXls}>
              <i className="fa fa-file-excel-o fa-fw" /> Export to Excel
            </Button>
          </div>
        )}

        {!horses.length && <Well>There are no registered horses yet</Well>}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Horses)


// WEBPACK FOOTER //
// ./src/components/Horses.js